(() => {
  // The CLI preview can reject POST /localization. Localized GET pages still work.
  // On storefront domains, keep Shopify's native localization form unchanged.
  if (!['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname)) return;

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches('form[data-local-language-selector]')) return;

    const select = form.querySelector('[name="language_code"]');
    const option = select?.selectedOptions[0];
    if (!option?.dataset.rootUrl) return;

    const normalizeRoot = (root) => root === '/' ? '' : root.replace(/\/$/, '');
    const currentRoot = normalizeRoot(form.dataset.languageRoot || '/');
    const targetRoot = normalizeRoot(option.dataset.rootUrl);
    const url = new URL(window.location.href);
    let path = url.pathname;

    // Only remove the current locale at a complete path boundary.
    if (currentRoot && (path === currentRoot || path.startsWith(currentRoot + '/'))) {
      path = path.slice(currentRoot.length) || '/';
    }

    url.pathname = targetRoot + path;
    url.searchParams.delete('locale');
    event.preventDefault();
    window.location.assign(url.href);
  });
})();
